import SplitType from 'split-type';

document.addEventListener( 'DOMContentLoaded', () => {
  new SplitType( '.e-hdn--fade-in', { types: 'lines' } ); //NOSONAR
  new SplitType( '.e-hdn--fade-in-word', { types: 'words' } ); //NOSONAR

  const isDesktop = window.matchMedia( '(min-width: 992px)' ).matches;
  if ( !isDesktop ) return;

  document.querySelectorAll( '.e-stn:not(.e-stn--slide-up-animation-trigger)' ).forEach( revealFadeInWithoutAnimation );

  const triggerSections = document.querySelectorAll( '.e-stn--slide-up-animation-trigger' );

  const observer = new IntersectionObserver( ( entries, observer ) => {
    entries.forEach( entry => {
      if ( !entry.isIntersecting ) return;
      const entrySection = entry.target;
      entrySection.classList.add( 'bs-appeared' );
      animateSection( entrySection );
      observer.unobserve( entrySection );
    } );
  }, { threshold: 0.3 } );

  triggerSections.forEach( section => observer.observe( section ) );
} );

function revealFadeInWithoutAnimation( section ) {
  section.querySelectorAll( '.e-div--fade-in, .e-prg--fade-in, .e-img--fade-in-3d' ).forEach( ( el ) => {
    el.style.opacity = '1';
    el.style.visibility = 'visible';
    el.style.animation = 'none';
  } );

  section.querySelectorAll( '.e-hdn--fade-in, .e-hdn--fade-in .line, .e-hdn--fade-in-word, .e-hdn--fade-in-word .word' ).forEach( ( el ) => {
    el.style.opacity = '1';
    el.style.visibility = 'visible';
    el.style.animation = 'none';
  } );
}

function animateSection( section ) {
  const fadeInDiv = section.querySelectorAll( '.e-div--fade-in' );
  const fadeInPrg = section.querySelectorAll( '.e-prg--fade-in' );
  const fadeInHdn = section.querySelectorAll( '.e-hdn--fade-in .line' );
  const fadeInHdnWord = section.querySelectorAll( '.e-hdn--fade-in-word .word' );
  const fadeIn3d = section.querySelector( '.e-img--fade-in-3d' );

  let delayOffset = 0.5;


  if ( fadeIn3d ) {
    fadeIn3d.style.animation = 'fadeIn3D 1.5s ease-in-out 0.3s forwards';
    delayOffset = 1.8;
  }

  const allOtherElements = sortByDomOrder( [
    ...fadeInDiv,
    ...fadeInPrg,
    ...fadeInHdn,
    ...fadeInHdnWord
  ] );
  const allOtherElementsLight = sortByDomOrder( [
    ...fadeInHdnWord
  ] );

  animateElements( allOtherElements, delayOffset );
  animateElementsLight( allOtherElementsLight, delayOffset );
}

function sortByDomOrder( elements ) {
  return Array.from( elements ).sort( ( a, b ) =>
    a.compareDocumentPosition( b ) && Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1
  );
}

function animateElements( elements, baseDelay ) {
  elements.forEach( ( el ) => {
    const isSpecial = el.classList.contains( 'line' );
    const duration = isSpecial ? '0.8s' : '1s';
    const delay = baseDelay;
    el.style.animation = `slideUp ${duration} ease ${delay}s forwards`;
  } );
}

function animateElementsLight( elementsLight, baseDelayLight ) {
  elementsLight.forEach( ( ele, index ) => {
    const isSpecialLight = ele.classList.contains( 'word' );
    const durationLight = isSpecialLight ? '0.8s' : '1s';
    const delayLight = baseDelayLight + index * 0.1;
    ele.style.animation = `fadeInLight ${durationLight} ease-in-out ${delayLight}s forwards`;
  } );
}